import { render, staticRenderFns } from "./DivisionListActions.vue?vue&type=template&id=51a27b6a"
import script from "./DivisionListActions.vue?vue&type=script&lang=js"
export * from "./DivisionListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports